export const getTranslations = state => state.locale.translations;

export const getCurrentLocale = state => state.locale.currentLocale;

export const isLocaleFetching = state => state.locale.isFetching;

export const translationsExist = state =>
  Object.keys(getTranslations(state)).length;

export const shouldFetchLocale = (state, languageKey) =>
  !isLocaleFetching(state) && getCurrentLocale(state) !== languageKey;

export const getString = (state, id, props) => {
  const translations = getTranslations(state);
  const keys = id.split(".");
  const translation = keys.reduce((acc, key) => {
    if (typeof acc === "object") {
      return acc[key] || false;
    } else {
      return acc;
    }
  }, translations);

  if (translation) {
    const tokenizer = /(%\{[^\}]+\})/,
      interpolation = /(%\{([^\}]+)\})/;
    // Split up found into tokens to separate any variables denoted
    //  by %{*}
    const tokens = translation.split(tokenizer);

    let t, i;
    for (i = tokens.length - 1; i >= 0; i--) {
      // Matching by interpolation will return an array with the name
      //  of the variable we want to replace that should be in our
      //  replacements object (passed in as an optional argument)
      t = tokens[i].match(interpolation);
      if (t) {
        if (props && props[t[t.length - 1]] !== undefined) {
          tokens[i] = props[t[t.length - 1]];
        }
      }
    }

    // React should render an array of these things correctly :fingerscrossed:
    return tokens;
    //return tokens.join("");
  } else {
    return translation;
  }
};

const path = `${window.location.origin}/img/locales`;

export const getLanguages = () => [
  { short: "en", long: "English", img: `${path}/en.png`, direction: "ltr" },
  { short: "ar", long: "العربية", img: `${path}/ar.png`, direction: "rtl" },
  { short: "bg", long: "Български", img: `${path}/bg.png`, direction: "ltr" },
  { short: "ca", long: "Català", img: `${path}/ca.png`, direction: "ltr" },
  { short: "cs", long: "čeština", img: `${path}/cs.png`, direction: "ltr" },
  { short: "cy", long: "Cymraeg", img: `${path}/cy.png`, direction: "ltr" },
  { short: "da", long: "Dansk", img: `${path}/da.png`, direction: "ltr" },
  { short: "de", long: "Deutsch", img: `${path}/de.png`, direction: "ltr" },
  { short: "el", long: "ελληνικά", img: `${path}/el.png`, direction: "ltr" },
  {
    short: "en_GB",
    long: "English (UK)",
    img: `${path}/en-GB.png`,
    direction: "ltr"
  },
  { short: "es", long: "Español", img: `${path}/es.png`, direction: "ltr" },
  {
    short: "es_MX",
    long: "Español - México",
    img: `${path}/es-MX.png`,
    direction: "ltr"
  },
  { short: "fi", long: "Suomi", img: `${path}/fi.png`, direction: "ltr" },
  { short: "fil", long: "Tagalog", img: `${path}/fil.png`, direction: "ltr" },
  {
    short: "fr_CA",
    long: "Français - Canada",
    img: `${path}/fr-CA.png`,
    direction: "ltr"
  },
  { short: "fr", long: "Français", img: `${path}/fr.png`, direction: "ltr" },
  { short: "ga", long: "Gaeilge", img: `${path}/ga.png`, direction: "ltr" },
  { short: "he", long: "עברית", img: `${path}/he.png`, direction: "rtl" },
  { short: "hi", long: "हिंदी", img: `${path}/hi.png`, direction: "ltr" },
  { short: "hu", long: "Magyar", img: `${path}/hu.png`, direction: "ltr" },
  { short: "is", long: "Íslenska", img: `${path}/is.png`, direction: "ltr" },
  { short: "it", long: "Italiano", img: `${path}/it.png`, direction: "ltr" },
  { short: "ja", long: "日本語", img: `${path}/ja.png`, direction: "ltr" },
  { short: "ko", long: "한국어", img: `${path}/ko.png`, direction: "ltr" },
  { short: "nl", long: "Nederlands", img: `${path}/nl.png`, direction: "ltr" },
  { short: "no", long: "Norsk", img: `${path}/no.png`, direction: "ltr" },
  { short: "pl", long: "Polski", img: `${path}/pl.png`, direction: "ltr" },
  {
    short: "pt_BR",
    long: "Português do Brasil",
    img: `${path}/pt-BR.png`,
    direction: "ltr"
  },
  { short: "pt", long: "Português", img: `${path}/pt.png`, direction: "ltr" },
  { short: "ro", long: "Română", img: `${path}/ro.png`, direction: "ltr" },
  { short: "ru", long: "Pусский", img: `${path}/ru.png`, direction: "ltr" },
  { short: "sv", long: "Svensk", img: `${path}/sv.png`, direction: "ltr" },
  { short: "th", long: "ภาษาไทย", img: `${path}/th.png`, direction: "ltr" },
  { short: "tr", long: "Türkçe", img: `${path}/tr.png`, direction: "ltr" },
  { short: "vi", long: "Tiếng Việt", img: `${path}/vi.png`, direction: "ltr" },
  {
    short: "zh_CN",
    long: "中文简体",
    img: `${path}/zh-CN.png`,
    direction: "ltr"
  },
  {
    short: "zh_TW",
    long: "繁體中文",
    img: `${path}/zh-TW.png`,
    direction: "ltr"
  }
];

export const getLanguage = lng =>
  getLanguages().find(language => language.short === lng);

export const getCurrentLanguage = state =>
  getLanguage(getCurrentLocale(state)) || {};

export const isRtlLang = (state, lang) =>
  ((lang && getLanguage(lang)) || getCurrentLanguage(state)).direction ===
  "rtl";
